import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import Icon from "@shared/components/Icon";
const ColumnsWithIcon = (props) => {
    const { id, dynamicList = [] } = props;
    return (_jsx(Stack, { direction: { xs: "column", lg: "row" }, justifyContent: "space-between", spacing: { xs: 2, lg: 0 }, sx: { py: 2.5 }, children: dynamicList.map((item) => (_jsxs(Stack, { spacing: 0.5, children: [item.title && (_jsxs(Stack, { direction: "row", spacing: 1, sx: { alignItems: "center" }, children: [item.icon?.icon && (_jsx(Box, { sx: {
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "primary.main",
                                minWidth: 16,
                                height: 16,
                            }, children: _jsx(Icon, { ...item.icon, style: { fontSize: "14px" } }) })), _jsx(Typography, { variant: "subtitle2", component: "p", sx: { color: "text.primary" }, children: item.title })] })), item.description && (_jsx(Typography, { variant: "caption", sx: { color: "text.secondary" }, children: item.description }))] }, item.title))) }, id));
};
export default ColumnsWithIcon;
